import { VALUE_UNRESOLVED } from '../../Consts/backoffice.const';
import {
  STRIPE_SUBSCRIPTION_STATUS_LABEL,
  STRIPE_SUBSCRIPTION_STATUS_TONE,
} from '../../Enums/stripe-status.enum';
import {
  SubscriptionCommitmentResponse,
  SubscriptionDetailResponse,
  SubscriptionItemResponse,
  SubscriptionPlanResponse,
} from '../../Interfaces/api/backoffice/subscription.interface';
import { StatusTone } from '../../Modules/Shared/Types/status-tone.type';

export class OrganizationSubscription {
  id = '';
  organization_id = '';
  stripe_subscription_id: string | null = null;
  stripe_status = '';
  stripe_customer_owned = false;
  plan: SubscriptionPlanResponse | null = null;
  seat_offer_type: string | null = null;
  started_at: string | null = null;
  trial_ends_at: string | null = null;
  current_period_start: string | null = null;
  current_period_end: string | null = null;
  cancel_at_period_end = false;
  canceled_at: string | null = null;
  last_stripe_event_at: string | null = null;
  commitment: SubscriptionCommitmentResponse = {
    is_committed: false,
    commitment_months: null,
    current_term_end: null,
    is_cancellable: true,
  };
  items: SubscriptionItemResponse[] = [];

  constructor(data: Partial<SubscriptionDetailResponse> = {}) {
    Object.assign(this, data);
  }

  get planLabel(): string {
    return this.plan?.name || this.plan?.code || VALUE_UNRESOLVED;
  }

  get statusLabelKey(): string {
    return STRIPE_SUBSCRIPTION_STATUS_LABEL[this.stripe_status] ?? this.stripe_status;
  }

  get statusTone(): StatusTone {
    return STRIPE_SUBSCRIPTION_STATUS_TONE[this.stripe_status] ?? 'neutral';
  }

  get currency(): string | null {
    return this.items[0]?.currency ?? null;
  }

  get isTrialing(): boolean {
    return this.stripe_status === 'trialing';
  }

  get isEndingAtPeriodEnd(): boolean {
    return this.cancel_at_period_end;
  }
}
